import React, { useEffect, useState } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import SubjectsFilters from '../components/BacSubjects/SubjectsFilters';
import SubjectsList from '../components/BacSubjects/SubjectsList';
import { SubjectsProvider } from '../contexts/SubjectsContext';
import { ArrowUp } from 'lucide-react';
import PageSEO from '../components/SEO/PageSEO';

const BacSubjectsPage = () => {
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);

    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 400);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  // Schéma JSON-LD pour les ressources éducatives
  const schema = {
    "@context": "https://schema.org",
    "@type": "LearningResource",
    "name": "Sujets de Bac SES et Corrigés",
    "description": "Collection de sujets de baccalauréat en Sciences Économiques et Sociales avec leurs corrigés vidéo détaillés, classés par type d'épreuve, année, chapitre et session.",
    "learningResourceType": "Exam Preparation",
    "educationalLevel": "High School",
    "provider": {
      "@type": "Organization",
      "name": "Comprendre les SES",
      "image": "https://cours-ses.fr/Logo SES.png"
    },
    "isAccessibleForFree": true,
    "teaches": "Sciences Économiques et Sociales",
    "educationalUse": "Exam Preparation",
    "assesses": [
      "Dissertation économique",
      "Épreuve composée partie 1",
      "Épreuve composée partie 2",
      "Épreuve composée partie 3"
    ],
    "educationalAlignment": [
      {
        "@type": "AlignmentObject",
        "alignmentType": "educationalSubject",
        "targetName": "Sciences Économiques et Sociales"
      },
      {
        "@type": "AlignmentObject",
        "alignmentType": "educationalLevel",
        "targetName": "Terminale"
      }
    ],
    "contentUrl": "https://cours-ses.fr/sujets-bac",
    "dateCreated": "2023-09-01",
    "dateModified": "2024-03-15"
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <PageSEO
        title="Sujets Bac SES | Annales et Corrigés Vidéo Gratuits"
        description="Tous les sujets de bac SES avec leurs corrigés vidéo détaillés. Dissertations, EC1, EC2, EC3 classés par année, chapitre et session pour réviser efficacement."
        path="/sujets-bac"
        image="https://cours-ses.fr/Logo SES.png"
        schema={schema}
      />
      <Navbar />
      <main className="pt-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <SubjectsProvider>
            <div className="text-center mb-12">
              <h1 className="text-4xl font-bold text-[#323c5f] mb-4">
                Sujets de Bac et Corrigés
              </h1>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                Retrouvez tous les sujets de bac SES avec leurs corrigés vidéo. 
                Des ressources complètes pour vous entraîner et réussir votre bac !
              </p>
            </div>
            
            <SubjectsFilters />
            <SubjectsList />
          </SubjectsProvider>
        </div>

        {/* Bouton retour en haut */}
        <button
          onClick={scrollToTop}
          className={`fixed bottom-8 right-8 bg-[#9a6ebd] text-white p-3 rounded-full shadow-lg hover:bg-[#8a5dad] transition-all duration-300 ${
            showScrollTop ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-16 pointer-events-none'
          }`}
          aria-label="Retour en haut"
        >
          <ArrowUp size={24} />
        </button>
      </main>
      <Footer />
    </div>
  );
};

export default BacSubjectsPage;